import { Spacer } from '@mythical/ui'
import { RenderBlocks } from 'app/components/blocks/RenderBlocks'
import ContentGrid from 'app/components/content/ContentGrid'
import { Meta } from 'app/components/primitive/Meta'
import QuarterlyCollectibles from 'app/components/primitive/QuarterlyCollectibles'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import SectionIntro from 'app/components/structure/SectionIntro'
import useMerchPage from 'app/hooks/use-merch-page'
import useQuery from 'app/hooks/use-query'
import {
  createCollectiblesQuery,
  mapToCollectibles,
} from 'app/queries/collectibles/list'
import { observer } from 'mobx-react-lite'
import React from 'react'

const query = createCollectiblesQuery()

export const MerchScreen = observer(() => {
  const { data } = useQuery(query, {}, mapToCollectibles)
  const { merchContent, pageContent } = useMerchPage()
  const pageContentBlocks = pageContent?.data?.pageContent || []

  return (
    <MainLayout
      contentStyles={{ bg: '$secondary10', flex: 1 }}
      noBottomTabs
      showBackBtn
    >
      <Meta title="Merch & Collectibles" slug="merch" />
      <SectionIntro
        title="Merch & Collectibles"
        description="Every 3 months, 3rd Degree Members receive exclusive Rhett & Link collectibles that you can't get anywhere else!"
        pb="$4"
      />
      <Spacer space="$4" />
      <QuarterlyCollectibles items={data} />
      {pageContentBlocks && (
        <RenderBlocks blocks={pageContentBlocks} slug="merch" spaced />
      )}
      {merchContent.data?.docs?.length > 0 && (
        <ContentGrid
          hasMore={merchContent.hasMore}
          isFetchingNextPage={merchContent.isFetchingNextPage}
          loading={merchContent.loading}
          items={merchContent.data?.docs}
          loadMore={() => merchContent.fetchMore()}
        />
      )}
    </MainLayout>
  )
})
